import actionTypes from './actionTypes';
import enums from '../../enums';

const INITIAL_STATE = {
  getAllUserCommentsLoading: false,
  getAllUserCommentsFailed: false,
  getAllUserCommentsError: false,
  getAllUserCommentsMessage: null,
  userCommentsList: [],
  userComments: {},

  getCommentsLoading: false,
  getCommentsFailed: false,
  getCommentsError: false,
  getCommentsMessage: null,
  commentsList: [],
  commentsTotalRecords: 0,

  replyToCustomerCommentLoading: false,
  replyToCustomerCommentFailed: false,
  replyToCustomerCommentError: false,
  replyToCustomerCommentMessage: null,

  updateCommentStatusLoading: false,
  updateCommentStatusFailed: false,
  updateCommentStatusError: false,
  updateCommentStatusMessage: null,

  editResponseLoading: false,
  editResponseFailed: false,
  editResponseError: false,
  editResponseMessage: null,

  changeCafeAccessToResponseLoading: false,
  changeCafeAccessToResponseFailed: false,
  changeCafeAccessToResponseError: false,
  changeCafeAccessToResponseMessage: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.INIT_COMMENTS_LIST: {
      return {
        ...state,
        getCommentsLoading: true,
        getCommentsFailed: false,
        getCommentsError: false,
        getCommentsMessage: null,
        commentsTotalRecords: 0,
        commentsList: []
      };
    }
    case actionTypes.GET_COMMENTS_LOADING: {
      return {
        ...state,
        getCommentsLoading: true,
        getCommentsFailed: false,
        getCommentsError: false,
        getCommentsMessage: null
      };
    }
    case actionTypes.GET_COMMENTS_SUCCESS: {
      let commentsList = [...action.payload.comments];
      if (action.payload.pageNumber > 1) {
        commentsList = [...state.commentsList, ...action.payload.comments];
      }

      return {
        ...state,
        getCommentsLoading: false,
        getCommentsFailed: false,
        getCommentsError: false,
        getCommentsMessage: null,
        commentsTotalRecords: action.payload.totalRecords,
        commentsList
      };
    }
    case actionTypes.GET_COMMENTS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getCommentsLoading: false,
        getCommentsFailed: true,
        getCommentsError: false,
        getCommentsMessage: message,
        commentsTotalRecords: 0,
        commentsList: []
      };
    }
    case actionTypes.GET_COMMENTS_REJECT: {
      return {
        ...state,
        getCommentsLoading: false,
        getCommentsFailed: false,
        getCommentsError: true,
        getCommentsMessage: null,
        commentsTotalRecords: 0,
        commentsList: []
      };
    }

    case actionTypes.INIT_USER_COMMENTS_LIST: {
      return {
        ...state,
        getAllUserCommentsLoading: true,
        getAllUserCommentsFailed: false,
        getAllUserCommentsError: false,
        getAllUserCommentsMessage: null,
        userCommentsTotalRecords: 0,
        userCommentsList: []
      };
    }
    case actionTypes.FETCH_USER_COMMENTS_LOADING: {
      return {
        ...state,
        getAllUserCommentsLoading: true,
        getAllUserCommentsFailed: false,
        getAllUserCommentsError: false,
        getAllUserCommentsMessage: null
      };
    }
    case actionTypes.FETCH_USER_COMMENTS_SUCCESS: {
      let userCommentsList = [...action.payload.comments];
      if (action.payload.pageNumber > 1) {
        userCommentsList = [...state.userCommentsList, ...action.payload.comments];
      }

      return {
        ...state,
        getAllUserCommentsLoading: false,
        getAllUserCommentsFailed: false,
        getAllUserCommentsError: false,
        getAllUserCommentsMessage: null,
        userCommentsList,
        userCommentsTotalRecords: action.payload.totalRecords
      };
    }
    case actionTypes.FETCH_USER_COMMENTS_REJECT: {
      return {
        ...state,
        getAllUserCommentsLoading: false,
        getAllUserCommentsFailed: false,
        getAllUserCommentsError: true,
        getAllUserCommentsMessage: null,
        userCommentsList: [],
        userCommentsTotalRecords: 0
      };
    }
    case actionTypes.FETCH_USER_COMMENTS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getAllUserCommentsLoading: false,
        getAllUserCommentsFailed: true,
        getAllUserCommentsError: false,
        getAllUserCommentsMessage: message,
        userCommentsList: [],
        userCommentsTotalRecords: 0
      };
    }

    case actionTypes.CLEAR_REPLY_TO_CUSTOMER_COMMENT: {
      return {
        ...state,
        replyToCustomerCommentLoading: false,
        replyToCustomerCommentFailed: false,
        replyToCustomerCommentError: false,
        replyToCustomerCommentMessage: null
      };
    }

    case actionTypes.REPLY_TO_CUSTOMER_COMMENT_LOADING: {
      return {
        ...state,
        replyToCustomerCommentLoading: true,
        replyToCustomerCommentFailed: false,
        replyToCustomerCommentError: false,
        replyToCustomerCommentMessage: null
      };
    }
    case actionTypes.REPLY_TO_CUSTOMER_COMMENT_SUCCESS: {
      const commentsList = [...state.commentsList];
      const comment = commentsList.find(x => x.id === action.payload.parentId);
      if (comment) {
        if (!comment.responses) {
          comment.responses = [];
        }
        comment.responses.push(action.payload);
        comment.canReplyByRseeUser = false;
        comment.canReplyByCafeUser = false;
      }

      const userCommentsList = [...state.userCommentsList];
      const userComment = userCommentsList.find(x => x.id === action.payload.parentId);
      if (userComment) {
        if (!userComment.responses) {
          userComment.responses = [];
        }
        userComment.responses.push(action.payload);
        userComment.canReplyByCafeUser = false;
        userComment.canReplyByRseeUser = false;
      }

      return {
        ...state,
        commentsList,
        replyToCustomerCommentLoading: false,
        replyToCustomerCommentFailed: false,
        replyToCustomerCommentError: false,
        replyToCustomerCommentMessage: null
      };
    }
    case actionTypes.REPLY_TO_CUSTOMER_COMMENT_REJECT: {
      return {
        ...state,
        replyToCustomerCommentLoading: false,
        replyToCustomerCommentFailed: false,
        replyToCustomerCommentError: true,
        replyToCustomerCommentMessage: null
      };
    }
    case actionTypes.REPLY_TO_CUSTOMER_COMMENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        replyToCustomerCommentLoading: false,
        replyToCustomerCommentFailed: true,
        replyToCustomerCommentError: false,
        replyToCustomerCommentMessage: message
      };
    }

    case actionTypes.UPDATE_COMMENT_STATUS_LOADING: {
      return {
        ...state,
        updateCommentStatusLoading: true,
        updateCommentStatusFailed: false,
        updateCommentStatusError: false,
        updateCommentStatusMessage: null
      };
    }
    case actionTypes.UPDATE_COMMENT_STATUS_SUCCESS: {
      const { id, status } = action.payload;

      const commentsList = [...state.commentsList];
      const comment = commentsList.find(x => x.id === id);
      if (comment) {
        comment.status = status;

        if (
          status === enums.COMMENT_STATUS.values.CONFIRMED &&
          (!comment.responses || !comment.responses.length)
        ) {
          comment.canReplyByCafeUser = true;
          comment.canReplyByRseeUser = true;
        }
      }

      const userCommentsList = [...state.userCommentsList];
      const userComment = userCommentsList.find(x => x.id === id);
      if (userComment) {
        userComment.status = status;

        if (
          status === enums.COMMENT_STATUS.values.CONFIRMED &&
          (!userComment.responses || !userComment.responses.length)
        ) {
          userComment.canReplyByCafeUser = true;
          userComment.canReplyByRseeUser = true;
        }
      }

      return {
        ...state,
        commentsList,
        userCommentsList,
        updateCommentStatusLoading: false,
        updateCommentStatusFailed: false,
        updateCommentStatusError: false,
        updateCommentStatusMessage: null
      };
    }
    case actionTypes.UPDATE_COMMENT_STATUS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        updateCommentStatusLoading: false,
        updateCommentStatusFailed: true,
        updateCommentStatusError: false,
        updateCommentStatusMessage: message
      };
    }
    case actionTypes.UPDATE_COMMENT_STATUS_REJECT: {
      return {
        ...state,
        updateCommentStatusLoading: false,
        updateCommentStatusFailed: false,
        updateCommentStatusError: true,
        updateCommentStatusMessage: null
      };
    }

    case actionTypes.SAVE_PREV_COMMENTS_LIST: {
      return {
        ...state,
        prevCommentsList: [...action.payload]
      };
    }
    case actionTypes.SAVE_PREV_USER_COMMENTS_LIST: {
      return {
        ...state,
        prevUserCommentsList: [...action.payload]
      };
    }

    case actionTypes.CLEAR_EDIT_RESPONSE_COMMENT_FORM: {
      return {
        ...state,
        editResponseLoading: false,
        editResponseFailed: false,
        editResponseError: false,
        editResponseMessage: null
      };
    }
    case actionTypes.EDIT_RESPONSE_COMMENT_LOADING: {
      return {
        ...state,
        editResponseLoading: true,
        editResponseFailed: false,
        editResponseError: false,
        editResponseMessage: null
      };
    }
    case actionTypes.EDIT_RESPONSE_COMMENT_SUCCESS: {
      const { message, parentId, id } = action.payload;

      const commentsList = [...state.commentsList];
      const comment = commentsList.find(x => x.id === parentId);
      if (comment) {
        const response = comment.responses.find(x => x.id === id);
        if (response) {
          response.message = message;
        }
      }

      const userCommentsList = [...state.userCommentsList];
      const userComment = userCommentsList.find(x => x.id === parentId);
      if (userComment) {
        const response = userComment.responses.find(x => x.id === id);
        if (response) {
          response.message = message;
        }
      }

      return {
        ...state,
        editResponseLoading: false,
        editResponseFailed: false,
        editResponseError: false,
        editResponseMessage: null,
        commentsList,
        userCommentsList
      };
    }
    case actionTypes.EDIT_RESPONSE_COMMENT_REJECT: {
      return {
        ...state,
        editResponseLoading: false,
        editResponseFailed: false,
        editResponseError: true,
        editResponseMessage: null
      };
    }
    case actionTypes.EDIT_RESPONSE_COMMENT_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        editResponseLoading: false,
        editResponseFailed: true,
        editResponseError: false,
        editResponseMessage: message
      };
    }

    case actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_LOADING: {
      return {
        ...state,
        changeCafeAccessToResponseLoading: true,
        changeCafeAccessToResponseFailed: false,
        changeCafeAccessToResponseError: false,
        changeCafeAccessToResponseMessage: null
      };
    }
    case actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_SUCCESS: {
      const { id, access } = action.payload;

      const commentsList = [...state.commentsList];
      const comment = commentsList.find(x => x.id === id);
      if (comment) {
        comment.isCafeAllowedToRespond = access;
      }

      const userCommentsList = [...state.userCommentsList];
      const userComment = userCommentsList.find(x => x.id === id);
      if (userComment) {
        userComment.isCafeAllowedToRespond = access;
      }

      return {
        ...state,
        commentsList,
        userCommentsList,
        changeCafeAccessToResponseLoading: false,
        changeCafeAccessToResponseFailed: false,
        changeCafeAccessToResponseError: false,
        changeCafeAccessToResponseMessage: null
      };
    }
    case actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        changeCafeAccessToResponseLoading: false,
        changeCafeAccessToResponseFailed: true,
        changeCafeAccessToResponseError: false,
        changeCafeAccessToResponseMessage: message
      };
    }
    case actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_REJECT: {
      return {
        ...state,
        changeCafeAccessToResponseLoading: false,
        changeCafeAccessToResponseFailed: false,
        changeCafeAccessToResponseError: true,
        changeCafeAccessToResponseMessage: null
      };
    }

    default:
      return state;
  }
};
